import { format as formatDate } from "date-fns";
import i18next from "i18next";

export const formatDataGridValue = (
  type: string,
  value: string | boolean | number,
  format:
    | ((value: boolean | number | string) => string)
    | "string"
    | "boolean"
    | "date"
) => {
  let textValue = "";
  if (value !== undefined) {
    if (format === "string") {
      textValue = i18next.exists(`productBasicInfo.${type}.${value}`)
        ? i18next.t(`productBasicInfo.${type}.${value}`)
        : "-";
    } else if (format === "boolean") {
      textValue = value ? "Ja" : "Nein";
    } else if (format === "date") {
      textValue = formatDate(new Date(value as string), "dd.MM.yyyy");
    } else {
      textValue = format(value);
    }

    return textValue;
  }

  return value;
};

export const formatCurrency = (value: string) => {
  const firstPart = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: value,
    currencyDisplay: "name",
  })
    .format(0)
    .replace(/[\d\s,]/g, "");

  const lastPart = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: value,
  })
    .format(0)
    .replace(/[\d\s,]/g, "");

  return `${firstPart} (${lastPart})`;
};
